import React, { createContext, useEffect, useMemo, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Subject } from "rxjs";

import { DEFAULT_TITLE, subjectTitle } from "../hooks/use-set-title";

export const NaviContext = createContext();

export const NaviContextProvider = ({ children: content, context }) => {
  const context$ = useMemo(() => new Subject(), []);
  useEffect(() => {
    context$.next(context);
  }, [context, context$]);

  const [title, setTitle] = useState(DEFAULT_TITLE);
  useEffect(() => {
    subjectTitle.subscribe((t) => {
      if (t !== DEFAULT_TITLE) {
        t = DEFAULT_TITLE + " - " + t;
      }

      setTitle(t);
    });
  }, []);

  return (
    <NaviContext.Provider value={{ context, context$, setTitle }}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {content}
    </NaviContext.Provider>
  );
};
